import React__default from 'react';
import { DatePicker, Label as Label$1, Button as Button$1, Calendar as Calendar$1, Group as Group$1, DateInput as DateInput$1, DateSegment as DateSegment$1, Popover as Popover$1, Dialog as Dialog$1, Heading as Heading$1, CalendarCell as CalendarCell$1, CalendarGrid as CalendarGrid$1 } from 'react-aria-components';

/**
 * A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */
const Root = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(DatePicker, props, children);
};
Root.displayName = "Root";
/** A label provides context for an input element. */
const Label = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Label$1, props, children);
};
Label.displayName = "Label";
/** A button allows a user to perform an action. */
const Button = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Button$1, props, children);
};
Button.displayName = "Button";
/** A calendar allows a user to select a single date from a date grid. */
const Calendar = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Calendar$1, props, children);
};
Calendar.displayName = "Calendar";
/**
 * An group represents a set of related UI controls.
 */
const Group = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Group$1, props, children);
};
Group.displayName = "Group";
const DateInput = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(DateInput$1, props);
};
DateInput.displayName = "DateInput";
/**
 * A date segment displays an individual unit of a date and time, and allows users to edit
 * the value by typing or using the arrow keys to increment and decrement.
 */
const DateSegment = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(DateSegment$1, props);
};
DateSegment.displayName = "DateSegment";
/** A popover displays content in context with a trigger element */
const Popover = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Popover$1, props);
};
Popover.displayName = "Popover";
/** A dialog is an overlay shown above other content in an application */
const Dialog = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Dialog$1, props);
};
Dialog.displayName = "Dialog";
/** Displays a heading */
const Heading = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Heading$1, props);
};
Heading.displayName = "Heading";
/** A CalendarCell renders an individual date within a CalendarGrid. */
const CalendarCell = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(CalendarCell$1, props);
};
CalendarCell.displayName = "CalendarCell";
/** A CalendarGrid renders an individual month within a Calendar. It accepts a function as its children, which is called to render a CalendarCell for each date.  */
const CalendarGrid = ({
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(CalendarGrid$1, props);
};
CalendarGrid.displayName = "CalendarGrid";
// exports
Root.displayName = 'Datepicker';
Button.displayName = 'Button';
Calendar.displayName = 'Calendar';
Label.displayName = 'Label';
Group.displayName = 'Group';
DateInput.displayName = 'DateInput';
DateSegment.displayName = 'DateSegment';
Popover.displayName = 'Popover';
Dialog.displayName = 'Dialog';
Heading.displayName = 'Heading';
CalendarCell.displayName = 'CalendarCell';
CalendarGrid.displayName = 'CalendarGrid';

/**
 * A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
 */
var Datepicker = Object.assign(Root, {
  Button,
  Calendar,
  Label,
  Group,
  DateInput,
  DateSegment,
  Popover,
  Dialog,
  Heading,
  CalendarCell,
  CalendarGrid
});

export { Datepicker as default };
